import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from "../../../../environments/environment";
import { Buffer } from 'buffer';
import { ApiKey, ApiKeyCreateInput, ApiKeyCreateResponse, ApiKeyUpdateInput } from '../../../model/models';

@Injectable({
  providedIn: 'root'
})
export class ApiKeysService {

  private http = inject(HttpClient);

  getApiKeys(tenantId: string): Observable<ApiKey[]> {
    let id = Buffer.from(tenantId).toString('base64')
    return this.http.get<ApiKey[]>(`${environment.yomaApiURL}/tenants/${id}/api_keys`);
  }

  createApiKey(tenantId: string, data: ApiKeyCreateInput): Observable<ApiKeyCreateResponse> {
    let id = Buffer.from(tenantId).toString('base64')
    return this.http.put<ApiKeyCreateResponse>(`${environment.yomaApiURL}/tenants/${id}/api_keys`, data);
  }

  getApiKey(tenantId: string, apiKey: string): Observable<ApiKey> {
    let id = Buffer.from(tenantId).toString('base64')
    let api_key_id = Buffer.from(apiKey).toString('base64')
    return this.http.get<ApiKey>(`${environment.yomaApiURL}/tenants/${id}/api_keys/${api_key_id}`);
  }

  updateApiKey(tenantId: string, apiKey: string, data: ApiKeyUpdateInput): Observable<ApiKey> {
    let id = Buffer.from(tenantId).toString('base64')
    let api_key_id = Buffer.from(apiKey).toString('base64')
    return this.http.put<ApiKey>(`${environment.yomaApiURL}/tenants/${id}/api_keys/${api_key_id}`, data);
  }

  deleteApiKey(tenantId: string, apiKey: string): Observable<any> {
    let id = Buffer.from(tenantId).toString('base64')
    let api_key_id = Buffer.from(apiKey).toString('base64')
    return this.http.delete(`${environment.yomaApiURL}/tenants/${id}/api_keys/${api_key_id}`);
  }
}
